import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const WorkoutProgramBuilder = ({ onCreateProgram, onUseAI }) => {
  const [programName, setProgramName] = useState('');
  const [selectedGoal, setSelectedGoal] = useState('');

  const goalOptions = [
    { value: 'strength', label: 'Strength Building' },
    { value: 'weight-loss', label: 'Weight Loss' },
    { value: 'muscle-gain', label: 'Muscle Gain' },
    { value: 'endurance', label: 'Endurance' },
    { value: 'flexibility', label: 'Flexibility' },
    { value: 'rehabilitation', label: 'Rehabilitation' },
  ];

  const recentPrograms = [
    {
      id: 1,
      name: 'Beginner Strength Program',
      clients: 8,
      duration: '8 weeks',
      exercises: 24,
      icon: 'Dumbbell',
    },
    {
      id: 2,
      name: 'HIIT Fat Burn',
      clients: 12,
      duration: '6 weeks',
      exercises: 18,
      icon: 'Flame',
    },
    {
      id: 3,
      name: 'Advanced Powerlifting',
      clients: 5,
      duration: '12 weeks',
      exercises: 32,
      icon: 'Trophy',
    },
  ];

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Dumbbell" size={24} color="var(--color-primary)" />
          </div>
          <div>
            <h2 className="text-xl font-semibold text-foreground">Workout Programs</h2>
            <p className="text-sm text-muted-foreground">Create and manage programs</p>
          </div>
        </div>
      </div>
      <div className="p-6 rounded-lg bg-gradient-to-br from-primary/10 to-accent/10 border border-primary/20 mb-6">
        <div className="flex items-start gap-4 mb-4">
          <div className="w-12 h-12 rounded-full bg-primary/20 flex items-center justify-center flex-shrink-0">
            <Icon name="Sparkles" size={24} color="var(--color-primary)" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-foreground mb-2">AI-Powered Program Builder</h3>
            <p className="text-sm text-muted-foreground mb-4">
              Let AI create personalized workout programs based on client goals, fitness level, and available equipment.
            </p>
            <Button variant="default" iconName="Wand2" iconPosition="left" onClick={onUseAI}>
              Generate with AI
            </Button>
          </div>
        </div>
      </div>
      <div className="space-y-4 mb-6">
        <Input
          label="Program Name"
          type="text"
          placeholder="Enter program name"
          value={programName}
          onChange={(e) => setProgramName(e?.target?.value)}
        />
        <Select
          label="Primary Goal"
          placeholder="Select goal"
          options={goalOptions}
          value={selectedGoal}
          onChange={setSelectedGoal}
        />
        <Button
          variant="outline"
          fullWidth
          iconName="Plus"
          iconPosition="left"
          onClick={onCreateProgram}
        >
          Create Custom Program
        </Button>
      </div>
      <div>
        <h3 className="text-base font-semibold text-foreground mb-3">Recent Programs</h3>
        <div className="space-y-3">
          {recentPrograms?.map((program) => (
            <div
              key={program?.id}
              className="flex items-center justify-between p-4 rounded-lg border border-border hover:border-primary/50 transition-all duration-250 cursor-pointer"
            >
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Icon name={program?.icon} size={20} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium text-foreground truncate">{program?.name}</h4>
                  <div className="flex flex-wrap items-center gap-3 text-xs text-muted-foreground mt-1">
                    <span className="flex items-center gap-1">
                      <Icon name="Users" size={12} />
                      {program?.clients} clients
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="Clock" size={12} />
                      {program?.duration}
                    </span>
                    <span className="flex items-center gap-1">
                      <Icon name="ListChecks" size={12} />
                      {program?.exercises} exercises
                    </span>
                  </div>
                </div>
              </div>
              <Button variant="ghost" size="sm" iconName="ChevronRight" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WorkoutProgramBuilder;